<template>
    <v-navigation-drawer v-model="showDrawer" app temporary>
        <!-- <v-list-item>
            <v-list-item-avatar>
                <v-img
                    src="https://randomuser.me/api/portraits/men/78.jpg"
                ></v-img>
            </v-list-item-avatar>

            <v-list-item-content>
                <v-list-item-title>John Leider</v-list-item-title>
            </v-list-item-content>
        </v-list-item> -->

        <!-- <v-divider></v-divider> -->

        <!-- <v-list>
            <v-subheader>Menu</v-subheader>
            <v-list-item
                v-for="(menu, i) in menus"
                :key="i"
                link
                :to="`${menu.path}`"
            >
                <v-list-item-icon>
                    <v-icon>{{ menu.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title>{{ menu.title }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>

        <v-divider></v-divider> -->

        <v-list class="mb-16" dense>
            <v-subheader class="justify-center">
                <router-link to="/" class="text-decoration-none text-h5 font-weight-bold">
                    <img 
                        style="width: 142px;"
                        src="@/assets/img/repttown_text.svg"
                        alt="Home"
                    />
                </router-link>
            </v-subheader>

            <v-subheader>{{ $langs.get('product.category') }}</v-subheader>
            <v-list-group v-for="(value, key) in route" :key="key" no-action>
                <template v-slot:activator>
                    <v-list-item-content>
                        <v-list-item-title v-if="key">{{ $langs.get(`gen.${key}`) }}</v-list-item-title>
                    </v-list-item-content>
                </template>

                <v-list-item
                    v-for="{ title, path, titleTh } in value"
                    :key="path"
                    class="pl-8"
                    :to="`/${key}/${path}`"
                >
                    <v-list-item-content>
                        <v-list-item-title>{{ $langs.getFunc(`product.subType`)({ title, titleTh }) }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list-group>
            
            <v-list-item to="/stores">
                <v-list-item-content>
                    <v-list-item-title>{{ $langs.get(`gen.stores`) }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <!-- <v-list-item to="/manual">
                <v-list-item-content>
                    <v-list-item-title class="d-flex">
                        {{ $langs.Gen.manual[$langs.lang] }}
                        <v-icon right small>mdi-book-open-variant</v-icon>
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item> -->
        </v-list>
    </v-navigation-drawer>
</template>

<script>
export default {
    props: ["value"],
    data() {
        return {
            menus: [{ title: "Home", path: "/", icon: "home" }],
            showDrawer: false,
            route: { loading: [] },
        };
    },
    methods: {
        async loadRoute() {
            let route = await this.$store.dispatch("GetRoute");
            if (!route) return;
            this.route = route;
        },
    },
    mounted() {
        this.showDrawer = this.value;
        this.loadRoute();
    },
    watch: {
        value() {
            // when opening drawer
            this.showDrawer = this.value;
        },
        showDrawer() {
            // when user close drawer, emit back to v-model
            this.$emit("input", this.showDrawer);
        },
    },
};
</script>

<style>
</style>